exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "h2[data-v-9f8a81aa]{width:100%;margin-top:0}.connectionImage[data-v-9f8a81aa]{width:50px;height:50px;margin:6px;border:2px solid #ccc;cursor:pointer;-webkit-transition:opacity 1.1s cubic-bezier(.25,.8,.25,1),border .5s ease,-webkit-filter 2.2s cubic-bezier(.25,.8,.25,1) .3s!important;transition:opacity 1.1s cubic-bezier(.25,.8,.25,1),border .5s ease,-webkit-filter 2.2s cubic-bezier(.25,.8,.25,1) .3s!important;transition:opacity 1.1s cubic-bezier(.25,.8,.25,1),filter 2.2s cubic-bezier(.25,.8,.25,1) .3s,border .5s ease!important;transition:opacity 1.1s cubic-bezier(.25,.8,.25,1),filter 2.2s cubic-bezier(.25,.8,.25,1) .3s,border .5s ease,-webkit-filter 2.2s cubic-bezier(.25,.8,.25,1) .3s!important}.connectionImage[data-v-9f8a81aa]:hover{border-color:#256}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9f8a81aa","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/profile/ConnectionOverview.vue
// module id = 874
// module chunks = 0